import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class GPSFilterGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var gpsFilterGrid = this;
		setTimeout(function(){
			gpsFilterGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var gpsFilterGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['DATA_FILTER_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['DATA_FILTER_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'gpsFilterId',
					header: 'Filter Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Name',
					width: '7em'
				},	
				{						
					path: 'defaultPreference',
					header: 'Default Preference',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.defaultPreference) {
							root.innerHTML = '<b>Default</b>';
						} else {
							root.innerHTML = '';
						}
					}
				},	
				{						
					path: 'driftingMaxDistance',
					header: 'Drifting Max Distance',
					width: '7em'
				},
				{						
					path: 'minTimeBetweenLocations',
					header: 'Min Time Between Points',
					width: '7em'
				},
				{						
					path: 'maxCrowFlyMph',
					header: 'Max Crow Fly MPH',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		gpsFilterGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			DataManagementService.getGPSFilteringService().getGPSFilters().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',											
											required: true,
											maxLength: 80											
										},
										{
											tag: 'vaadin-number-field',										
											name: 'driftingMaxDistance',
											label: 'Drift Max Distance',											
											required: true,
											value: 0.5,
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-number-field',										
											name: 'minTimeBetweenLocations',
											label: 'Min Time Between (minutes)',											
											required: true,
											value: 5,
											min: 0,
											max: 1000
										},									
										{
											tag: 'vaadin-number-field',										
											name: 'maxCrowFlyMph',
											label: 'Max Crow Fly MPH',											
											required: true,
											value: 150,
											min: 0,
											max: 1000
										},
										{
											tag: 'vaadin-checkbox',
											name: 'defaultPreference',
											label: 'Company Default'																	
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
																	
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {
																	if (record) {
																		data.gpsFilterId = record.gpsFilterId;
																	}
																	return DataManagementService.getGPSFilteringService().saveGPSFilter(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved GPS Filter', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						if (record) {
							formPanel.load(record);
						}
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This filter will be removed from associated Integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getGPSFilteringService().deleteGPSFilter(record.gpsFilterId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
	}
	
}
customElements.define('dl-gpsfilter-grid', GPSFilterGrid);
